import React from "react";
import {
  ChartContainer,
  Subtitle,
  Title,
  TitleWrapper,
} from "../FactSheetChart/index.styled";
import CbsaCancerGrowthChart from "../../graph/cbsaCancerGrowthChart";

const FactSheetGrowthChart = ({ data, cbsa }) => {
  const formatCbsa = (text) => {
    if (text) {
      let [cbsaNumber, cbsaName] = text?.split(" - ");
      return cbsaName ? `${cbsaName} - ${cbsaNumber}` : cbsaNumber;
    }
  };
  const cbsaName = formatCbsa(cbsa);

  return (
    <ChartContainer>
      <TitleWrapper>
        <Title>{cbsaName}</Title>
        {data && <Subtitle>Cancer Case Growth Rate in CBSA </Subtitle>}
      </TitleWrapper>
      {data && <CbsaCancerGrowthChart data={data} />}
      {!data && (
        <Subtitle style={{ color: "#cf6c58", fontWeight: "600" }}>
          No Cancer Growth Rate Data available{" "}
        </Subtitle>
      )}
    </ChartContainer>
  );
};

export default FactSheetGrowthChart;
